Vue.component('start-card-answer', {
    props: {
        index: Number,
    },
    template: `
        <a @click.stop.prevent href="#" @click="handleClick" class='start-card-answer'>
        Continue
        </a>
    `,

    methods: {
        handleClick(e) {
            e.preventDefault();
            Bus.$emit('navigateToCard', 1);
        },
    },
});

Vue.component('end-card-answer', {
    props: {
        index: Number,
        surveyItem: Object,
        resultUrl: String
    },
    template: `
        <a v-if="resultUrl" :href="resultUrl" @click="openSurvey" class='end-card-answer'>
        FINISH
        </a>
    `,

    methods: {
        openSurvey(e) {
            e.preventDefault();
            window.location.href = this.resultUrl;
        },
    },

    computed: {
    }
});

Vue.component('survey-answer', {
    props: {
        index: Number,
        value: Number,
        surveyItem: Object,
        selected: Boolean
    },
    data() {
        return {
            answer: {}
        }
    },
    template: `
        <a @click.stop.prevent href="#" @click="handleClick" :class='computedClass' class="test-survey-answer">
        {{value}}
        </a>
    `,
    computed: {
        computedClass() {
            if (this.selected) {
                return 'selected survey-answer';
            }
            return 'survey-answer';
        }
    },
    methods: {
        handleClick(e) {
            e.preventDefault();
            this.answer.value = this.value;
            Bus.$emit('answerSelected', this.answer);
        },
    },
    mounted() {
        this.answer.question_id = this.surveyItem.id;
    }

});

Vue.component('survey-answer-section', {
    props: {
        index: Number,
        surveyItem: Object,
        active: Boolean,
        resultUrl: String
    },
    data() {
        return {
            question: this.surveyItem
        }
    },
    template: `
        <div class="survey-answer-section">
        <start-card-answer v-if="surveyItem.question_type == 'start-card'"></start-card-answer>
        <end-card-answer v-else-if="surveyItem.question_type == 'end-card'" :survey-item="question" :result-url="resultUrl"></end-card-answer>
        <survey-answer v-else v-for="value in values"
                       :tabindex="tabable"
                       :index="index"
                       :value="value"
                       :survey-item="question"
                       :selected="value == selected"
                       v-bind:key="value.id"
        ></survey-answer>
        </div>
    `,
    computed: {
        values() {
            switch (this.surveyItem.question_type) {
                case "int_1_5":
                    return [1, 2, 3, 4, 5];
                case "int_1_10":
                    return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
                case "int_0_10":
                    return [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
            }
        },
        selected() {
            if (this.question.answers.length) {
                return this.question.answers[0].value;
            } else {
                return -1;
            }
        },
        tabable() {
            return this.active ? 0 : -1;
        }
    },
});

Vue.component('survey-item', {
    props: {
        surveyItem: Object,
        index: Number,
        activeCard: Number,
        resultUrl: String
    },
    data() {
        return {};
    },
    template: `
        <div @click.stop.prevent @click="handleClick" :class="customClass" :id="surveyItem.question_slug">
<!--        <div :class="customClass" :id="surveyItem.question_slug">-->
        <div class="survey-icon">
            <icon-base>
                <component v-bind:is="cardIcon"></component>
                </icon-user>
            </icon-base></div>

        <div class="survey-title">{{surveyItem.category}}</div>
        <div class="survey-question" v-html="surveyItem.question_text"></div>
        <div v-if="surveyItem.question_type === 'end-card'" class="survey-instructions" v-html="surveyItem.instruction_text"></div>
        <div v-if="surveyItem.question_type !== 'end-card'" class="survey-instructions" v-html="surveyItem.instruction_text"></div>

        <survey-answer-section :survey-item="surveyItem" :active="active" :index="index" :result-url="resultUrl"></survey-answer-section>
        <div @click="clickSecondaryButton" :class="secondaryButtonClass">{{this.secondaryButtonText}}</div>
        </div>
    `,

    methods: {
        classFormat(input) {
            return input.replace(/ /g, "-").toLowerCase();
        },
        handleClick() {
            if (this.index < this.activeCard) {
                Bus.$emit('navigateToCard', this.index);
            }
        },
        clickSecondaryButton() {
            switch(this.surveyItem.question_type){
                case "start-card":
                    break;
                case "end-card":
                    break;
                default:
                    Bus.$emit('navigateToCard', this.index - 1);
            }
        }
    },
    computed: {
        cardIcon() {
            if(this.surveyItem.question_type == "start-card" || this.surveyItem.question_type == "end-card") {
                return "icon-user";
            } else {
                return "icon-" + this.classFormat(this.surveyItem.category);
            }
        },
        secondaryButtonText() {
            switch(this.surveyItem.question_type){
                case "start-card":
                    return "";
                case "end-card":
                    return "";
                default:
                    return "GO BACK";
            }
        },
        secondaryButtonClass() {
            return this.active ? "secondary-button active" : "secondary-button"
        },
        active() {
            return this.index === this.activeCard;
        },
        customClass() {
            if (this.active) {
                return this.classFormat(this.surveyItem.category) + ' active survey-item ' + this.surveyItem.question_type
            } else {
                return this.classFormat(this.surveyItem.category) + ' survey-item ' + this.surveyItem.question_type
            }
        },
    },
});

Vue.component('survey-list', {
    props: {
        surveyInstance: Object,
        surveyTemplate: Object,
    },
    data() {
        return {
            activeCard: 0
        }
    },

    template: `
        <div class="survey-list" v-bind:class="{ 'is-last': isLastCard }">
        <survey-item v-for="(question, index) in surveyTemplate.questions"
                     :survey-item="question"
                     :index="index"
                     :active-card="activeCard"
                     :result-url="surveyInstance.result_url"
                     v-bind:key="question.id"
        ></survey-item>
        </div>
    `,

    computed: {
        isLastCard() {
            return this.activeCard === this.surveyTemplate.questions.length - 1;
        }
    },
    methods: {
        navigateToCard(index) {
            this.activeCard = index;
            let root = document.documentElement;
            root.style.setProperty('--card-index', this.activeCard);
        }
    },
    created() {
        let dateOptions = {
            day: "numeric",
            month: "long"
        };

        let procedureDate = new Date(this.surveyInstance.procedure_date).toLocaleDateString('en-AU', dateOptions);
        let startCard = {
            category: this.surveyInstance.surgeon_name,
            question_text: `Hi ${this.surveyInstance.patient_name}, This is a 2 minute survey about your health after your procedure on ${procedureDate}.`,
            question_type: "start-card",
            instruction_text: "Please respond to each question or statement by selecting the most appropriate response.<br>If you need to pause answering the survey, you can come back to it later."
        };
        this.surveyTemplate.questions.splice(0,0, startCard);

        let endCard = {
            category: this.surveyInstance.surgeon_name,
            question_text: "Thank you for your time! ",
            instruction_text: "<br> This information has been collected for quality purposes and may not be reviewed immediately. If you have any concerns about your recovery from your surgery, please contact your doctor directly.",

            question_type: "end-card",
        }
        this.surveyTemplate.questions.splice(this.surveyTemplate.questions.length,0, endCard);

    },
    mounted() {
        Bus.$on('navigateToCard', (index) => {
            this.navigateToCard(index);
        });

        Bus.$on('answerSelected', (answer) => {
            answer.token = this.surveyInstance.token;
            answer.survey_instance_id = this.surveyInstance.id;

            this.navigateToCard(this.activeCard + 1);

            axios.post('/api/answer', answer)
                .then(response => {
                    let question = this.surveyTemplate.questions.find(q => {
                        return q.id === response.data.question_id;
                    });
                    question.answers.splice(0, 1, response.data);
                })
                .catch(response => {
                    this.navigateToCard(this.activeCard - 1);

                    console.error('error');
                });
        });
    },
});
